import { createTheme } from '@mui/material/styles';

// Create the base theme with neutral colors
const baseTheme = createTheme({
  palette: {
    primary: {
      main: '#2c3e50', // Dark blue-grey
      light: '#3c5876',
      dark: '#1e2b38',
    },
    secondary: {
      main: '#34495e', // Slightly lighter blue-grey
      light: '#4c6b8a',
      dark: '#243342',
    },
  },
  typography: {
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
    ].join(','),
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none', // Prevents automatic uppercase transformation
        },
      },
    },
  },
});

export default baseTheme; 